import { useSearchParams } from "react-router-dom";
import { useUserStore } from "../stores/userStore";
import { TypeCategory, TypeQuerySearch, SortByOption } from "../app/index";
import { calculateMaxFilter } from "../utils/filterUtils";
import _ from "lodash";

export const useFilterParams = (
  setquerySearch: (value: TypeQuerySearch) => void,
  querySearch: TypeQuerySearch
) => {
  let [searchParams] = useSearchParams();
  const { user } = useUserStore();

  const keywords = searchParams.get("keywords");
  const sortbyParam = searchParams.get("sortby");

  const query: TypeQuerySearch = {
    rangeValue: rangeValidation(
      searchParams.get("pmin"),
      searchParams.get("pmax"),
      user.collections
    ),

    keyword: keywords !== "null" && keywords ? keywords : "",
    categories: categoryConverter(searchParams.get("category")?.split(","), user.categories),
    sortby: validateSortBy(sortbyParam),
  };

  if (_.isEqual(query, querySearch) === false) {
    setquerySearch(query);
  }

  return { query };
};

const categoryConverter = (catParam: string[] | undefined, sessionCategories: any[]) => {
  const cats: TypeCategory[] = [];
  if (catParam) {
    catParam.forEach((element) => {
      sessionCategories.forEach((category) => {
        if (category.key === element) cats.push(category);
      });
    });
  }
  return cats;
};

const rangeValidation = (
  min: string | undefined | null,
  max: string | undefined | null,
  collections: Array<{ amount: number }> = []
) => {
  // Calcola dinamicamente il maxFilter basato sulle collections
  const dynamicMaxFilter = calculateMaxFilter(collections);
  const effectiveMaxFilter = dynamicMaxFilter > 0 ? dynamicMaxFilter : 0;
  
  let pmin = 0; // Default minimo sempre 0
  let pmax = effectiveMaxFilter;

  if (min !== "null") {
    pmin =
      min !== undefined && min !== null ? Number(min) : 0;
  }

  if (max !== "null") {
    pmax =
      max !== undefined && max !== null ? Number(max) : effectiveMaxFilter;
  }

  if (pmin < 0) pmin = 0;

  if (pmin > effectiveMaxFilter) pmin = effectiveMaxFilter;

  if (pmax < 0 || pmax > effectiveMaxFilter) pmax = effectiveMaxFilter;

  if (pmin > pmax) {
    pmin = 0;
  }

  return [pmin, pmax];
};

const validateSortBy = (sortbyParam: string | null): SortByOption => {
  const validSortByOptions: SortByOption[] = ['prezzo_crescente', 'prezzo_decrescente', 'brand_crescente', 'brand_decrescente'];
  
  if (sortbyParam && validSortByOptions.includes(sortbyParam as SortByOption)) {
    return sortbyParam as SortByOption;
  }
  
  return 'brand_crescente';
};
